import React, { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';

type LanguageContextType = {
    lang: string | null;
    setLang: Dispatch<SetStateAction<null | string>>;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

type LanguageProviderProps = {
    children: ReactNode;
};

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const [lang, setLang] = useState<string | null>(localStorage.getItem('language'));

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
